/* src/app/modules/finanzas/paymentcard/tarjeta-credito/paymentcard-dialog-movimiento-tarjeta-credito.component.css */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.mtc-header-text {
  min-width: 0;
  padding-right: 32px;
}
.mtc-body {
  padding: 0 !important;
}
.mtc-section {
  padding: 18px 24px 8px;
}
.mtc-section + .mtc-section {
  border-top: 1px solid #f0f0f0;
}
.mtc-section__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.mtc-section__total {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.mtc-link {
  border: 0;
  background: transparent;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
  color: #6b7280;
  text-decoration: underline;
  cursor: pointer;
}
.mtc-link:hover {
  color: #1a1d23;
}
.mtc-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0 16px;
}
.mtc-grid__wide {
  grid-column: span 2;
}
.mtc-suffix {
  font-size: 14px;
  color: #9ca3af;
  font-weight: 500;
  margin-right: 6px;
}
.mtc-rows {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-bottom: 10px;
}
.mtc-row {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 12px;
  padding: 8px 8px 8px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
}
.mtc-row--editing {
  border-color: #c5d94a;
  background: #fbfee8;
}
.mtc-row__date {
  font-size: 13px;
  color: #6b7280;
  white-space: nowrap;
}
.mtc-row__main {
  min-width: 0;
}
.mtc-row__concept {
  font-size: 13px;
  font-weight: 600;
  color: #1a1d23;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mtc-row__meta {
  margin-top: 2px;
  font-size: 12px;
  color: #6b7280;
  overflow-wrap: anywhere;
}
.mtc-row__amount {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.mtc-row__actions {
  display: flex;
  flex-shrink: 0;
}
.mtc-row__btn {
  width: 34px !important;
  height: 34px !important;
  padding: 5px !important;
  color: #6b7280 !important;
}
.mtc-row__btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.mtc-row__btn--danger:hover {
  color: #dc2626 !important;
}
.mtc-empty {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.mtc-empty mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.mtc-empty--error mat-icon {
  color: #dc2626;
}
@media (max-width: 768px) {
  .mtc-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 520px) {
  .mtc-grid {
    grid-template-columns: 1fr;
  }
  .mtc-grid__wide {
    grid-column: auto;
  }
  .mtc-row {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .mtc-row__date {
    grid-column: 1 / -1;
  }
}
/*# sourceMappingURL=paymentcard-dialog-movimiento-tarjeta-credito.component.css.map */
